const nonNullableToCamel = <T = unknown>(item: unknown) =>
  item === null || item === undefined ? item : camelize<T>(item);

export const camelize = <T = unknown>(item: NonNullable<unknown>): T => {
  if (Array.isArray(item)) {
    return item.map((el: unknown) => nonNullableToCamel(el)) as T;
  }

  if (typeof item === 'function' || item !== Object(item)) {
    return item as T;
  }

  // Не трогаем фрагменты после двойного подчёркивания (tag__slugs → остаётся tag__slugs, не tagSlugs)
  const toCamelKey = (str: string) =>
    str.replace(/(?<![-_])([-_][a-z])/gi, (c) => c.toUpperCase().replace(/[-_]/g, ''));

  return Object.fromEntries(
    Object.entries(item as Record<string, unknown>).map(([key, value]) => [toCamelKey(key), nonNullableToCamel(value)]),
  ) as T;
};
